import { render, staticRenderFns } from "./SuggestedPrompts.vue?vue&type=template&id=781ac52a&scoped=true&lang=pug"
import script from "./SuggestedPrompts.js?vue&type=script&lang=js&external"
export * from "./SuggestedPrompts.js?vue&type=script&lang=js&external"
import style0 from "./SuggestedPrompts.vue?vue&type=style&index=0&id=781ac52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781ac52a",
  null
  
)

export default component.exports